import { render, staticRenderFns } from "./GLBXCQ.vue?vue&type=template&id=3615330d&scoped=true"
import script from "./GLBXCQ.vue?vue&type=script&lang=js"
export * from "./GLBXCQ.vue?vue&type=script&lang=js"
import style0 from "./GLBXCQ.vue?vue&type=style&index=0&id=3615330d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3615330d",
  null
  
)

export default component.exports